import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CommonDataService} from "../../common/common-data.service";
import {AboutMeService} from "../about-me.service";
import {CommonService} from "../../common/common.service";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import {Constants} from "../../common/constants";
import {PasswordValidator} from "../../validators/PasswordValidator";
import {Mailbox} from "../../manage-mailbox/mailbox";
import {ManageMailboxService} from "../../manage-mailbox/manage-mailbox-service";
import {AuthService} from "../../common/auth.service";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  constants = Constants;
  isMobileScreen: boolean = false;
  mobileScreenSubscription: any;

  newPasswordFocused: boolean = false;
  confirmPasswordFocused: boolean = false;
  confirmPasswordPassed: boolean = false;
  passwordForm: FormGroup;
  hideCurrentPw: boolean = true;
  hideNewPw: boolean = true;
  shouldDisplayCurrentPassword: boolean = true;
  selectedMailbox: Mailbox;
  loading: boolean = false;
  footer: string;
  hasLinkedIasAccount: boolean;

  @Input()
  forgotPasswordUserName: string;

  @Input()
  brand: string;

  navigationExtras: NavigationExtras = {
    state: {
      selectedMailBox: null
    }
  };

  constructor(private commonService: CommonService, public commonDataService: CommonDataService, private aboutMeService: AboutMeService, private fb: FormBuilder, private router: Router, private mailBoxService: ManageMailboxService, private authService: AuthService, protected route: ActivatedRoute) {
    const navigation = this.router.getCurrentNavigation();
    let state = null;
      if (navigation) {
        state = navigation.extras.state as {
          selectedMailBox: Mailbox
        };
      }

    if (state) {
      // from manage mailboxes
      this.selectedMailbox = state.selectedMailBox;
    }

    if (this.selectedMailbox) {
      this.shouldDisplayCurrentPassword = !this.commonDataService.csrMode;
    } else {
      this.shouldDisplayCurrentPassword = true;
    }
  }

  ngOnInit() {
    this.mobileScreenSubscription = this.commonService.isMobileWindow$.subscribe(result =>{
      this.isMobileScreen = result;
    });
    this.createPasswordForm();
    this.hasLinkedIasAccount = this.commonDataService.linkedAccounts.some(account => account?.sourceSystem?.toUpperCase() === 'IAS');
  }

  ngOnDestroy() {
    if (this.mobileScreenSubscription) {
      this.mobileScreenSubscription.unsubscribe();
    }
  }

  createPasswordForm() {
    let userName = this.forgotPasswordUserName? this.forgotPasswordUserName: this.commonDataService.user.userId;
    this.passwordForm = this.fb.group({
      currentPassword: ['', this.shouldDisplayCurrentPassword? Validators.required: null],
      newPassword: ['', [
        Validators.required,
        PasswordValidator.containsCorrectLength(this.commonDataService.siteDetails.maxPasswordLength),
        PasswordValidator.containsLowerCase,
        PasswordValidator.containsUpperCase,
        PasswordValidator.containsNumber,
        PasswordValidator.notBasedOnUsername(userName),
        PasswordValidator.notContainsSpacedOrTabs]],
      confirmPassword: ['', Validators.required]
    }, {validator:PasswordValidator.matchPassword})
  }

  submitPassword() {
    this.loading = true;
      if (this.selectedMailbox) {
        this.selectedMailbox.password = this.passwordForm.controls["newPassword"].value;
        this.mailBoxService.updateMailBoxSettings(this.selectedMailbox).subscribe((result: boolean) => {
          if (result) {
            this.navigationExtras.state.selectedMailBox = this.selectedMailbox;
            this.router.navigateByUrl("/" + Constants.ABOUT_ME_PATH + "/" + Constants.CHANGE_PASSWORD_SUCCESS_PATH, this.navigationExtras);
          } else {
            this.openSnackBar();
          }
        }, error => {
          this.openSnackBar();
        })
      } else {
        let userName = this.forgotPasswordUserName? this.forgotPasswordUserName: this.commonDataService.user.userId;
        let currentPassword = this.passwordForm.controls["currentPassword"].value;
        let newPassword = this.passwordForm.controls["newPassword"].value;
        let brand = this.brand? this.brand: this.commonDataService.brand;

        this.aboutMeService.updatePassword(userName, currentPassword, newPassword, brand).subscribe((result: any) => {
            if (result) {
              if (this.commonDataService.isFirstTimeLogin) {
                this.commonDataService.isFirstTimeLogin = false;
                window.location.replace("/" + Constants.DASHBOARD_PATH);
              }
              else if (this.forgotPasswordUserName) {
                this.redirectToLoginPage();
              } else {
                this.router.navigateByUrl("/" + Constants.ABOUT_ME_PATH + "/" + Constants.CHANGE_PASSWORD_SUCCESS_PATH);
              }
            } else {
              this.openSnackBar();
            }
          },
          error => {
            this.openSnackBar();
          });
      }
  }

  redirectToLoginPage() {
    this.commonService.getLoginPageUrlByBrand(this.brand).subscribe((result: any) => {
      window.location.replace(`${result.url}?returnUrl=`);
    }, error => {
      console.log("error retrieving login page");
    })
  }

  openSnackBar() {
    this.loading = false;
    this.commonService.openSnackBar("Your password did not update successfully. Please try again.");
  }

  cancel() {
    if (this.commonDataService.isFirstTimeLogin) {
      this.redirectToLoginPage();
    } else {
      if (this.selectedMailbox) {
        this.router.navigateByUrl('/' + Constants.MANAGE_MAILBOX_PATH + '/' + Constants.MAILBOX_SETTINGS_PATH);
      } else {
        this.router.navigateByUrl('/' + Constants.ABOUT_ME_PATH);
      }
    }
  }
}
